import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FacetValue, ProductFacet } from '@kion/data-models';
import { Checkbox } from '../../../../../../../shared/ui/src/lib/shared/elements/checkbox/checkbox.component';

@Component({
  selector: 'kion-filter-list-item',
  templateUrl: './filter-list-item.component.html',
  styleUrls: ['./filter-list-item.component.scss']
})
export class FilterListItemComponent implements OnInit, OnChanges{

  @Input() item: ProductFacet;
  @Input() showValues = true;

  // tslint:disable-next-line:no-output-rename
  @Output('boxToggled') checkboxToggledEmitter: EventEmitter<Checkbox> = new EventEmitter<Checkbox>();

  boxes: Checkbox[];

  ngOnInit(): void {
    this.loadBoxes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item) {
      this.item = changes.item.currentValue;
      this.loadBoxes();
    }
  }

  private loadBoxes(): void {
    this.boxes = this.item.values.map(
      (value: FacetValue) => {
        return {
          title: value.name,
          required: false,
          isLink: false,
          checked: value.selected,
          query: value.query?.query?.value
        }
      }
    );
  }

  toggleValues() {
    this.showValues = !this.showValues;
  }

  boxToggled(box: Checkbox) {
    this.checkboxToggledEmitter.emit(box);
  }
}
